import { SlotType as t, CardVariant as a } from "./atoms-v2109.js";
function u(e) {
  return e[0].toUpperCase() + e.slice(1);
}
function n(e) {
  return e + "Text";
}
function c(e) {
  return e === t.Media;
}
function o(e, r) {
  switch (e) {
    case t.Media:
      return !!r.mediaSrc;
    case t.CallToAction:
      return !!r.callToActionText;
    case t.Footer:
      return !!r.footerText;
    case t.Header:
      return !!r.headerText;
    case t.SubHeader:
      return !!r.subheaderText;
    case t.Body:
      return !!r.bodyText;
    default:
      return !1;
  }
}
function d(e) {
  return typeof e != "function";
}
function s(e, r) {
  switch (e) {
    case a.Horizontal:
      return "1/1";
    case a.Standard:
      return "16/9";
    case a.Feature:
    default:
      return r === "small" ? "3/2" : "2/1";
  }
}
export {
  s as getMediaAspectRatio,
  d as isClickIgnored,
  o as isDerivedByContentProps,
  c as isMedia,
  u as withCap,
  n as withText
};
